import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {
  Country,
  EventItem,
  Lookups,
  UserDetail
} from "@model";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {
  MY_TRACEY_FAVORITES,
  MY_TRACEY_OVERVIEW, MY_TRACEY_RESULTS,
  MY_TRACEY_UPCOMING, MY_TRACEY_ORDERS
} from "../../../../app-routing.module";
import {filter} from 'rxjs';

export enum MyTraceyTabs {
  OVERVIEW = 1,
  UPCOMING = 2,
  FAVORITES = 3,
  RESULTS = 4,
  ORDERS = 5
}
export enum MyTraceyComponentState {
  TABS = 1,
  EDIT = 2,
  MY_ENTRY = 4,
  MY_ORDER = 5,
  PERSONAL_INFO = 6,
}


@Component({
    selector: 'app-my-tracey',
    templateUrl: './my-tracey.component.html',
    styleUrl: './my-tracey.component.scss',
    standalone: false
})
export class MyTraceyComponent extends AbstractComponent implements OnInit {

  @Input({required: true}) languages: Lookups[] = [];
  @Input() currentUserDetails: UserDetail | undefined;
  @Input() countries: Country[] = [];
  @Input() recommendedEvents: EventItem[] = [];

  currentTab: MyTraceyTabs | undefined;
  state: MyTraceyComponentState | undefined;

  showOverviewTab: boolean = false;
  showTabs: boolean = false;


  constructor(private router: Router, public translocoService: TranslocoService, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {

    this.isMobile$.subscribe(_ => {
      this.initViewFields();
    })

    this.subscribeToRouteDataChange();
    this.setComponentState(this.route.firstChild)
  }


  goBack() {
      this.router.navigate([this.MY_TRACEY_OVERVIEW]);
  }


  private subscribeToRouteDataChange() {
    this.subscriptions.push(this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe(() => {
          this.setComponentState(this.route.firstChild)
        })
    )
  }

  private setComponentState(activatedRoute: ActivatedRoute | null) {
    this.currentTab = activatedRoute?.snapshot.data['activeTab'];
    this.state = activatedRoute?.snapshot.data['state'];
    this.initViewFields();
  }

  private initViewFields() {
    if (this.isMobile) {
        this.showOverviewTab = false;
        this.showTabs = this.currentTab !== MyTraceyTabs.OVERVIEW;
    }
    else {
        this.showTabs = true;
        this.showOverviewTab = true;
    }
  }



  protected readonly MyTraceyTabs = MyTraceyTabs;
  protected readonly MyTraceyComponentState = MyTraceyComponentState;

  protected readonly MY_TRACEY_OVERVIEW = MY_TRACEY_OVERVIEW;
  protected readonly MY_TRACEY_UPCOMING = MY_TRACEY_UPCOMING;
  protected readonly MY_TRACEY_FAVORITES = MY_TRACEY_FAVORITES;
  protected readonly MY_TRACEY_RESULTS = MY_TRACEY_RESULTS;
  protected readonly MY_TRACEY_ORDERS = MY_TRACEY_ORDERS;

}
